const actions = {
  PACKAGE_DATA_FETCH_BEGIN: 'PACKAGE_DATA_FETCH_BEGIN',
  PACKAGE_DATA_FETCH_SUCCESS: 'PACKAGE_DATA_FETCH_SUCCESS',
  PACKAGE_DATA_FETCH_ERR: 'PACKAGE_DATA_FETCH_ERR',

  packageDataFetchBegin: () => ({
    type: actions.PACKAGE_DATA_FETCH_BEGIN,
  }),

  packageDataFetchSuccess: (data) => ({
    type: actions.PACKAGE_DATA_FETCH_SUCCESS,
    data,
  }),

  packageDataFetchErr: (err) => ({
    type: actions.PACKAGE_DATA_FETCH_ERR,
    err,
  }),
};

export const {
  PACKAGE_DATA_FETCH_BEGIN,
  PACKAGE_DATA_FETCH_SUCCESS,
  PACKAGE_DATA_FETCH_ERR,
  packageDataFetchBegin,
  packageDataFetchSuccess,
  packageDataFetchErr,
} = actions;

export default actions;
